var map = {
	"./ion-action-sheet-ios.entry.js": [
		"sMrV",
		0,
		21
	],
	"./ion-action-sheet-md.entry.js": [
		"l4V/",
		0,
		22
	],
	"./ion-alert-ios.entry.js": [
		"EYCs",
		0,
		23
	],
	"./ion-alert-md.entry.js": [
		"vOt4",
		0,
		24
	],
	"./ion-app_8-ios.entry.js": [
		"OOe6",
		0,
		25
	],
	"./ion-app_8-md.entry.js": [
		"yg28",
		0,
		26
	],
	"./ion-avatar_3-ios.entry.js": [
		"NdRF",
		0,
		27
	],
	"./ion-avatar_3-md.entry.js": [
		"Q6Wl",
		0,
		28
	],
	"./ion-back-button-ios.entry.js": [
		"Tj1G",
		0,
		29
	],
	"./ion-back-button-md.entry.js": [
		"QZ2j",
		0,
		30
	],
	"./ion-backdrop-ios.entry.js": [
		"2kZA",
		31
	],
	"./ion-backdrop-md.entry.js": [
		"Pjiz",
		32
	],
	"./ion-button_2-ios.entry.js": [
		"3reL",
		0,
		33
	],
	"./ion-button_2-md.entry.js": [
		"hzOp",
		0,
		34
	],
	"./ion-card_5-ios.entry.js": [
		"IQAb",
		0,
		35
	],
	"./ion-card_5-md.entry.js": [
		"5l/J",
		0,
		36
	],
	"./ion-checkbox-ios.entry.js": [
		"TktL",
		0,
		37
	],
	"./ion-checkbox-md.entry.js": [
		"nBtn",
		0,
		38
	],
	"./ion-chip-ios.entry.js": [
		"G9sj",
		0,
		39
	],
	"./ion-chip-md.entry.js": [
		"C44O",
		0,
		40
	],
	"./ion-col_3.entry.js": [
		"m06n",
		41
	],
	"./ion-datetime_3-ios.entry.js": [
		"I1le",
		0,
		42
	],
	"./ion-datetime_3-md.entry.js": [
		"7WYZ",
		0,
		43
	],
	"./ion-fab_3-ios.entry.js": [
		"nnCh",
		0,
		44
	],
	"./ion-fab_3-md.entry.js": [
		"UicT",
		0,
		45
	],
	"./ion-img.entry.js": [
		"4mo6",
		46
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		"D6T7",
		0,
		47
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		"0no5",
		0,
		48
	],
	"./ion-input-ios.entry.js": [
		"tDQI",
		0,
		49
	],
	"./ion-input-md.entry.js": [
		"WAxt",
		0,
		50
	],
	"./ion-item-option_3-ios.entry.js": [
		"M24W",
		0,
		51
	],
	"./ion-item-option_3-md.entry.js": [
		"fbSv",
		0,
		52
	],
	"./ion-item_8-ios.entry.js": [
		"7pC5",
		0,
		53
	],
	"./ion-item_8-md.entry.js": [
		"w1dZ",
		0,
		54
	],
	"./ion-loading-ios.entry.js": [
		"TGWc",
		0,
		55
	],
	"./ion-loading-md.entry.js": [
		"23VQ",
		0,
		56
	],
	"./ion-menu_3-ios.entry.js": [
		"EE8I",
		0,
		57
	],
	"./ion-menu_3-md.entry.js": [
		"eBXd",
		0,
		58
	],
	"./ion-modal-ios.entry.js": [
		"gie4",
		0,
		59
	],
	"./ion-modal-md.entry.js": [
		"Ob8z",
		0,
		60
	],
	"./ion-nav_2.entry.js": [
		"wRbG",
		0,
		61
	],
	"./ion-popover-ios.entry.js": [
		"m3uf",
		0,
		62
	],
	"./ion-popover-md.entry.js": [
		"qRLi",
		0,
		63
	],
	"./ion-progress-bar-ios.entry.js": [
		"K024",
		0,
		64
	],
	"./ion-progress-bar-md.entry.js": [
		"Wxwr",
		0,
		65
	],
	"./ion-radio_2-ios.entry.js": [
		"+6S/",
		0,
		66
	],
	"./ion-radio_2-md.entry.js": [
		"3ZkI",
		0,
		67
	],
	"./ion-range-ios.entry.js": [
		"VxsH",
		0,
		68
	],
	"./ion-range-md.entry.js": [
		"ub3G",
		0,
		69
	],
	"./ion-refresher_2-ios.entry.js": [
		"XS5Z",
		0,
		70
	],
	"./ion-refresher_2-md.entry.js": [
		"eePr",
		0,
		71
	],
	"./ion-reorder_2-ios.entry.js": [
		"an5R",
		0,
		72
	],
	"./ion-reorder_2-md.entry.js": [
		"7XOp",
		0,
		73
	],
	"./ion-ripple-effect.entry.js": [
		"7y2o",
		74
	],
	"./ion-route_4.entry.js": [
		"j6cJ",
		0,
		75
	],
	"./ion-searchbar-ios.entry.js": [
		"Ju03",
		0,
		76
	],
	"./ion-searchbar-md.entry.js": [
		"w7jv",
		0,
		77
	],
	"./ion-segment_2-ios.entry.js": [
		"4B1M",
		0,
		78
	],
	"./ion-segment_2-md.entry.js": [
		"9Vmc",
		0,
		79
	],
	"./ion-select_3-ios.entry.js": [
		"4Ziy",
		0,
		80
	],
	"./ion-select_3-md.entry.js": [
		"aVv8",
		0,
		81
	],
	"./ion-slide_2-ios.entry.js": [
		"EgzI",
		82
	],
	"./ion-slide_2-md.entry.js": [
		"AwDb",
		83
	],
	"./ion-spinner.entry.js": [
		"y9YI",
		0,
		84
	],
	"./ion-split-pane-ios.entry.js": [
		"WE+1",
		85
	],
	"./ion-split-pane-md.entry.js": [
		"HaWZ",
		86
	],
	"./ion-tab-bar_2-ios.entry.js": [
		"5jDp",
		0,
		87
	],
	"./ion-tab-bar_2-md.entry.js": [
		"K6of",
		0,
		88
	],
	"./ion-tab_2.entry.js": [
		"2ByS",
		0,
		89
	],
	"./ion-text.entry.js": [
		"nERb",
		0,
		90
	],
	"./ion-textarea-ios.entry.js": [
		"KoUA",
		0,
		91
	],
	"./ion-textarea-md.entry.js": [
		"3EqC",
		0,
		92
	],
	"./ion-toast-ios.entry.js": [
		"ImJM",
		0,
		93
	],
	"./ion-toast-md.entry.js": [
		"JCqu",
		0,
		94
	],
	"./ion-toggle-ios.entry.js": [
		"NE97",
		0,
		95
	],
	"./ion-toggle-md.entry.js": [
		"hCM4",
		0,
		96
	],
	"./ion-virtual-scroll.entry.js": [
		"x+YG",
		97
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "YENW";
module.exports = webpackAsyncContext;